import { Injectable, OnDestroy } from "@angular/core";
import { io } from "socket.io-client";
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class AmpelChatService implements OnDestroy {
  private socket: any;
  constructor() {}

  connectToServer(username, partnerid, cb) {
    if (username && username.length > 0 && !this.socket) {
      try {
        const tocken = window.localStorage.getItem(partnerid + "_access_token");
        let url = "https://" + document.domain;
        if (!environment.production) {
          url = "http://localhost:33330";
        }
        const namespace = partnerid?.replace(/-/g, "_");
        this.socket = io(url + "/" + namespace, {
          transports: ["websocket"],
          query: {
            token: tocken,
            username: username,
            namespace: namespace,
            partnerid: partnerid,
          },
        });

        this.socket.on("connect", () => {
          cb(null);
        });

        this.socket.on("connect_error", (error) => {
          console.log(`connect_error due to ${error.message}`);
          cb(error);
        });

        this.socket.on("kill", () => {
          this.socket.disconnect();
        });
      } catch (error) {
        cb(error);
      }
    } else {
      cb(null);
    }
  }

  
  ngOnDestroy(): void {
    this.socket && this.socket.disconnect();
    this.socket = null;
  }

  async updateample(partnerid, email, cb) {
    const token = window.localStorage.getItem(partnerid + "_access_token");
    this.socket.emit(
      "getwebchatusersforampelnewconn",
      { token: token, username: email },
      (users) => {
        cb(users);
      }
    );
  }
}
